import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';


interface SCardProps {
  /**
   * Card title
   */
  title?: string,
  /**
   * Card subtitle
   */
  subtitle?: string,
  /**
   * Card icon, displayed as large icon on the left of title and subtitle
   */
  icon?: string,
  /**
   * Whether the card is disabled. If true, all card content and actions are disabled
   */
  disabled?: boolean,
  /**
   * Whether the card is outlined or not
   */
  outlined?: boolean
  /**
   * Card size
   */
  size?: 'default' | 'small' | 'large',
  /**
   * Whether the card has padding or not
   */
  padding?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SCard',
  props: {
  title: { default: '' },
  subtitle: { default: '' },
  icon: { default: '' },
  disabled: { type: Boolean, default: false },
  outlined: { type: Boolean, default: true },
  size: { default: 'default' },
  padding: { type: Boolean, default: true }
},
  setup(__props) {

const props = __props;


const hasTitleContent = _computed(() => !!props.title || !!props.subtitle || !!props.icon);

const titleClass = _computed(() => ({
  'body-1': props.size === 'default',
  'body-2': props.size === 'small',
  'text-h5': props.size === 'large',
}));

const subtitleClass = _computed(() => ({
  caption: props.size === 'default' || props.size === 'small',
  'body-2': props.size === 'large',
}));

const iconStyle = _computed(() => ({
  'margin-top': props.size === 'large' ? '4px' : '',
}));


return { __sfc: true,props, hasTitleContent, titleClass, subtitleClass, iconStyle, _computed }
}

})